module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAV0lEQVR4AWMYHCCNQ/g/kCIdw8A5QbX/QEMoMwBqCAUGIAwh1wAEft455T8RANUAdPyspZ98A561TyTfBRmuhv8ZqmyJwzCAppkMAxCayTMAqpl0PDwAAInFLP4AI40UAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PS.png
// module id = 1245
// module chunks = 0